// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3TCPE","notes":"Notes_notes__O7Ng9","note":"Notes_note__ainvg","markdown":"Notes_markdown__dGKaw"};